<div
  class="d-flex flex-column flex-root bgi-size-cover bgi-attachment-fixed bgi-position-center bgi-no-repeat bg-primary"
  [ngStyle]="{
    'background-image': company?.bgAuth
      ? 'url(' + company?.bgAuth + ')'
      : 'none'
  }"
>
  <div class="d-flex flex-column flex-column-fluid flex-lg-row">
    <div class="d-flex flex-center w-lg-50 pt-15 pt-lg-0 px-10">
      <div class="d-flex flex-center flex-lg-start flex-column">
        <a routerLink="/" class="mb-12 mx-auto">
          <img
            alt="Logo"
            [src]="company?.logoAuth.contentUrl"
            [ngStyle]="{ height: company?.logoAuthHeight + 'px' }"
          />
        </a>
        <h2
          class="d-none d-lg-block text-white fw-normal text-center mb-7 mx-auto"
          *ngIf="company?.authLogoSubtitle"
        >
          {{ company?.authLogoSubtitle }}
        </h2>
      </div>
    </div>

    <div
      class="d-flex flex-row-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12 p-lg-20 auth-login-right"
    >
      <div
        class="bg-body d-flex flex-column align-items-stretch flex-center rounded-4 w-md-600px p-8 w-100"
      >
        <div
          class="d-flex flex-center flex-column flex-column-fluid px-lg-10 pb-15 pb-lg-20"
        >
          <router-outlet></router-outlet>
        </div>

        <div class="d-none d-lg-block fs-7 text-center">
          <p>
            Todos os Direitos Autorais Reservados à {{ company?.companyName }}
            <br />
            {{ company?.address }}, {{ company?.district }} <br />
            {{ company?.city?.name }} - {{ company?.city?.state }} | CEP
            {{ company?.zipCode }} <br />
            Fone:
            <a
              class="ms-2 opacity-75-hover"
              href="https://wa.me/55{{ item }}"
              target="_blank"
              *ngFor="let item of company?.phones; let i = index"
            >
              <i class="bi bi-whatsapp text-primary fw-bold me-1"></i>
              {{ item | mask : getPhoneMaskValue(item) }}
              <span *ngIf="company?.phones[i + 1]" class="ms-2"> | </span>
            </a>
          </p>
          <!-- <img src="./assets/media/logos/logo-upweb.png" height="30" /> -->
        </div>
      </div>

      <div class="d-lg-none fs-base text-center text-white mt-9">
        <p>
          Todos os Direitos Autorais Reservados à {{ company?.companyName }}
        </p>
        <p>
          {{ company?.address }}, {{ company?.district }} <br />
          {{ company?.city?.name }} - {{ company?.city?.state }} | CEP
          {{ company?.zipCode }} <br />
        </p>
        <p>
          Fone:
          <a
            class="ms-2 opacity-75-hover"
            href="https://wa.me/55{{ item }}"
            target="_blank"
            *ngFor="let item of company?.phones; let i = index"
          >
            <i class="bi bi-whatsapp text-primary fw-bold me-1"></i>
            {{ item | mask : getPhoneMaskValue(item) }}
            <span *ngIf="company?.phones[i + 1]" class="ms-2"> | </span>
          </a>
        </p>
        <!-- <img src="./assets/media/logos/logo-upweb-white.png" height="30" /> -->
      </div>
    </div>
  </div>
</div>
